let map;

window.addEventListener('turbo:load', (e) => {
  if (document.getElementById('map')) {
    initMap();
  }
})

document.addEventListener("turbo:before-cache", function() {
  if (document.getElementById('map') && map) {
    map.destroy();
  }
})

async function initMap() {
    await ymaps3.ready;

    ymaps3.import.registerCdn('https://cdn.jsdelivr.net/npm/{package}', '@yandex/ymaps3-default-ui-theme@latest');

    const {YMap, YMapDefaultSchemeLayer, YMapDefaultFeaturesLayer, YMapControls, YMapMarker} = ymaps3;
    const {YMapZoomControl} = await ymaps3.import('@yandex/ymaps3-default-ui-theme');

    map = new YMap(
      document.getElementById('map'),
      {
        location: {
          center: [60.692648572772875, 56.76501004924172],
          zoom: window.innerWidth < 600 ? 10 : 13
        },
        behaviors: ['drag', 'pinchZoom', 'dblClick'],
      },
      [
        new YMapDefaultSchemeLayer({}),
        new YMapDefaultFeaturesLayer({id: 'features'})
      ]
    );

    if (window.CLINICS_COORDS) {
      JSON.parse(window.CLINICS_COORDS).forEach((el) => {
        const
          markerElement = document.createElement('div'),
          imgElement = document.createElement('img');

        markerElement.classList.add('icon-marker');
        imgElement.src = window.PIN_IMG;
        markerElement.style.width = '32px';
        markerElement.style.height = '32px';

        markerElement.appendChild(imgElement);

        const marker = new YMapMarker(
          {
            coordinates: [el.longitude, el.latitude],
            draggable: false
          },
          markerElement);
        map.addChild(marker);
      })
    }

    const controls = new YMapControls({position: 'right'});
    controls.addChild(
      new YMapZoomControl({
        easing: 'linear'
      })
    );

    map.addChild(controls);
}
